import makeStyles from '@mui/styles/makeStyles'
import clsx from 'clsx'
import React from 'react'

import Lottie from 'react-lottie'
import ttdLoader from '../../../assets/animations/ttd-loader-infinite.json'

const styles = (size: any) => ({
    Loader: {
        '& div': {
            width: `${size}rem !important`,
            height: `${size}rem !important`,
        },
    },

    LoaderHasErrors: {
        '& svg *': {
            fill: '#ff0000',
        },
    },
})

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: ttdLoader,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
}

const Loader = ({ hasErrors = false, size = 5 }) => {
    const useStyles = makeStyles(() => ({
        ...styles(size),
    }))
    const classes = useStyles()
    return (
        <div className={clsx(classes.Loader, hasErrors && classes.LoaderHasErrors)}>
            <Lottie options={defaultOptions} height="2.5rem" width="2.5rem" speed={2} />
        </div>
    )
}

export default Loader
